import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import AddCircleOutlineRounded from '@mui/icons-material/AddCircleOutlineRounded';

import graph from './graph';
import schema from './schema';
import uiSchema from './uiSchema';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { isEmptyObject } from 'helpers/formatObject';
import { MuiFormBuilder, NewDialog, NewDialogActions, NewDialogContent, NewDialogTitle } from 'components';

export default function Create({ label = 'create-coupon', title = 'تعریف بن جدید', refetch }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [init, setInit] = useState(formData);
  const { userToken } = useSelector((state) => state.auth);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const [formUpdate, { loading }] = useMutation(graph.create.query, {
    context: {
      serviceName: graph.create.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onChange = ({ formData }) => {
    setInit((prev) => ({ ...prev, ...formData }));
  };

  const onSubmit = async ({ formData }) => {
    try {
      const { data, errors } = await formUpdate({
        variables: formData,
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.create.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  return (
    <>
      <Button
        size="small"
        color="secondary"
        variant="outlined"
        onClick={onOpen}
        disabled={loading}
        endIcon={<AddCircleOutlineRounded fontSize="small" />}
      >
        افزودن بن جدید
      </Button>
      <NewDialog label={label} open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
            <MuiFormBuilder
              id={label}
              formData={init}
              onSubmit={onSubmit}
              showSubmit={false}
              liveValidate={false}
              schema={schema()}
              uiSchema={uiSchema(init)}
            />
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            form={label}
            type="submit"
            size="medium"
            color="success"
            variant="contained"
            sx={{ minWidth: 80 }}
            disabled={loading}
            endIcon={<DoneRoundedIcon />}
          >
            ثبت
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
